import React from 'react';
import DataMetrics from '../dataMetrics';
import { FiClock } from 'react-icons/fi';

const Timings = ({ timings }) => {
  return (
    <React.Fragment>
      <DataMetrics
        classes="text-center bg-gray"
      >
        <span>
          <FiClock /> Timings 
        </span>
      </DataMetrics>
      <DataMetrics>
        <ul className="full-width">
          {timings.map((value, index) => {
            return (
              <li key={index} className={value.includes('Closed') ? 'timings-closed' : ''}>
                {value}
              </li>
            )
          })}
        </ul>
      </DataMetrics>
    </React.Fragment>
  )
}
export default Timings;